<template>
  <div class="header">
    <h1>Product Guides</h1>
  </div>
  <br />
  <div class="cards">
    <!-- <article class="card">
      <img src="../assets/mpk-ntf-toolkit-thumb.png" alt="Sample photo" />
      <div class="text">
        <h3>Non-Traditional Feeding Toolkit</h3>
        <br />
        <p>Focused on IW and products conducive to offsite feeding.</p>
        <br />
        <div class="showguide">
          <router-link to="/NTFToolkit">Show Guide</router-link>
        </div>
      </div>
    </article> -->
    <article class="card">
      <img src="../assets/mpk-gfs-stocking-list-thumb.png" alt="Sample photo" />
      <div class="text">
        <h3>GFS Stocking List</h3>
        <br />
        <!-- <p>Focused on items in stock at GFS conducive to offsite feeding.</p>
        <br /> -->
        <div class="showguide">
          <router-link to="/GFSStockList">Show Guide</router-link>
        </div>
      </div>
    </article>
    <article class="card">
      <img src="../assets/mpk-clems-stocking-list-thumb.png" alt="Sample photo" />
      <div class="text">
        <h3>Clems Stocking List</h3>
        <br />
        <div class="showguide">
          <router-link to="/ClemsStockList">Show Guide</router-link>
        </div>
      </div>
    </article>
    <!-- <article class="card">
      <img src="../assets/mpk-virtual-roadshow-menu-2020-thumb.png" alt="Sample photo" />
      <div class="text">
        <h3>MPK Virtual Roadshow 2020 Menu</h3>
        <br />
        <p>Products presented at the MPK Virtual Roadshow 2020.</p>
        <br />
        <div class="showguide">
          <router-link to="/MPKVirtualRoadshow2020Menu">Show Guide</router-link>
        </div>
      </div>
    </article> -->
  </div>
</template>

<script>
// .. is an alias to /src
export default {
  name: "ProductGuides",
  components: {},
};
</script>

<style scoped>
.header {
  margin-top: 20px;
}
.list {
  margin-top: 20px;
  text-align: center;
}
.grid-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: auto 1fr;
  gap: 0px 0px;
  grid-template-areas: "left middle right";
  height: 100%;
  margin: 0;
}
/* .grid-container * {
  border: 1px solid red;
  position: relative;
}

.grid-container *:after {
  content:attr(class);
  position: absolute;
  top: 0;
  left: 0;
} */
.left {
  grid-area: left;
}
.middle {
  grid-area: middle;
}
.right {
  grid-area: right;
}
.cards {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}
.card {
  flex: 0 0 250px;
  margin: 10px;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.3);
}
.card img {
  max-width: 100%;
}
.card .text {
  padding: 0 10px;
}
/* .card .text .showguide > a {
  color: whitesmoke;
} */

.showguide {
  background: slategray;
  /* color: whitesmoke; */
  padding: 10px;
  margin: 5px auto;
  text-align: center;
  font-weight: bold;
}

.text h3 {
  text-align: center;
}
</style>